<template>
	<div class="page-news" ref="page_news" @scroll="handleScroll">
		<div class="page_container" ref="page_container">
			<!-- <div class="news-header">
				<div class="news-column">
					<div 
						v-for="item in columnList"
						:key="item.title"
						:class="['column', {active: columnId === item.id}]"
						@click="handleClickTab(item)"
						>
							{{item.title}}
					</div>
				</div>
			</div> -->
			
			<div >
					<!-- <keep-alive> -->
						<news-list :list="list"/>
					<!-- </keep-alive> -->
			</div>
			<div class="page-footer">
				<loading v-show="loading">
					<span class="more-text">正在加载</span>
				</loading>
				<div class="loadmore_line" v-if="list.length == 0 && !loading">
					<span class="loadmore__tip">暂无数据</span>
				</div>
				<div class="loadmore_line" v-if="noMoreData && list.length !== 0">
					<span class="loadmore__over"></span>
				</div>
			</div>
			<div style="height: 3rem;"></div>
		</div>
	</div>
</template>
<script>
	import axios from 'axios'
	import NewsList from '../components/NewsList'
	import Loading from '../components/Loading'

	export default{
		name: 'news',
		data(){
			return {
				columnId: undefined,
				columnList: [],
				list: [],
				page: 1,
				timestamp: undefined,
				loading: false,
				noMoreData: false
			}
		},
		components: {
			NewsList,
			Loading
		},
		created(){
			this.getData()
		},
		mounted(){

		},
		methods: {
			getData(data){
				if(this.noMoreData) return
				this.loading = true
				const params = {
					columnId: 1005,
					page: this.page,
					timestamp: this.timestamp
				}
				axios({
					url: '/cdfb/Index/article/articleList',
					method: 'POST',
					data: Object.assign(params, data)
				}).then(rep => {
					const {data, code, msg} = rep.data
					if(code == 0){
						this.list = this.list.concat(data.list)
						if(data.list.length == 0 ){
							this.noMoreData = true
						}
						this.page = data.page
						this.timestamp = data.timestamp
						if(data.columnList){
							this.columnList = data.columnList
							this.columnId = this.columnList[0].id
						}
					} else {
						console.log(msg)
					}
					this.loading = false
				})
			},
			handleClickTab(item){
				this.noMoreData = false
				this.columnId = item.id
				this.page = 1
				this.timestamp = undefined
				this.list = []

				this.getData({columnId: item.id})
			},
			handleScroll(e){
				const scrollH = e.target.scrollTop
				const pageH = this.$refs.page_container.scrollHeight || this.$refs.page_container.clientHeight
				const cH = document.documentElement.scrollHeight || document.body.scrollHeight
				clearTimeout(this.timer)
				this.timer = setTimeout(()=>{
					if(scrollH + cH +200 > pageH){
						console.log('wakkk')
						this.getData()
					}

				},100)
				
			}
		}
	}
</script>
<style>
	.page-news{
		background: #fff;
    height: 100vh;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
	}
	.news-header{
		width: 100%;
		/*position: sticky;
		top: 0;*/
		overflow: hidden;
		background: #fff;
		overflow-x: auto;
		z-index: 10;
	}
	.page-footer{
		height: 1.5rem;
		padding: .2rem 0;
	}
	.news-column{
		display: flex;
		flex-flow: row nowrap;
		height: 2.5rem;
		align-items: center;
	}
	.news-column .column{
		flex-shrink: 0;
		margin: 0 .7rem;
		font-size: .8rem;
		color: #868B95;
		position: relative;
	}
	.news-column .column.active{
		font-size: 1rem;
		color: #0E141D;
	}
	.news-column .column.active::after{
		content: "";
		display: block;
		width: .8rem;
		padding: 0 .2rem;
		height: .2rem;
		background: #4186E6;
		border-radius: .2rem;
		position: absolute;
		left: 50%;
		transform: translate(-50%, 0);
		bottom: -.4rem;
	}
	.loadmore_line{
		width: 65%;
    margin: 1rem auto;
    text-align: center;
    font-size: 0;
    border-top: 1px solid rgba(0,0,0,.1)
	}
	.loadmore_line .loadmore__tip{
		position: relative;
		background: #fff;
		color: rgba(0,0,0,.6);
		top: -0.9em;
		font-size: .7rem;
		padding: 0 0.55em;
	}
	.loadmore__over{
		padding: 0 0.16em;
    position: relative;
    top: -0.9em;
    background: #fff;
    display: inline-block;
    font-size: 14px;
	}
	.loadmore__over::after{
		content: " ";
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: rgba(0,0,0,0.1);
    background-color: rgba(0,0,0,0.1);
    display: inline-block;
    position: relative;
    vertical-align: 0;
    top: -0.16em;
	}
</style>